export default "__VITE_ASSET__BcsgvIWv__"